module.exports = __webpack_public_path__ + "img/q1.17098864.png";